import { Coord } from "../types/Interface";
import Point from "./Point";


export default class RedPoint extends Point {
  tag: string;
  constructor(tag: string, coord: Coord, handleDown: (p: string) => void, handleUp: () => void) {
    super(coord);
    this.interactive = true;
    this.tag = tag;
    this.fillColor = 0xFF0000;
    this.cursor = "grab"

    this.on("mousedown", () => handleDown(this.tag));
    this.on("touchstart", () => handleDown(this.tag));
    this.on("mouseup", () => handleUp());
    this.on("touchend", () => handleUp());
  }
}